import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Collapse,
  Label,
} from 'reactstrap';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import moment from 'moment';
import Excel from 'exceljs';
import FileSaver from 'file-saver';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable2 from 'react-bootstrap-table-next';
import DataEmptyState from '../../../commons/dataemptystate';
import QueryEmptyState from '../../../commons/queryempty';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from '../services';
import { DatePicker, DatetimePicker, PaginationTotal } from '../../../commons/controls';
import NumberFormatter from '../../../commons/NumberFormatter';
import CustomTooltip from '../../../components/Tooltip/CustomTooltip';
import getTooltip from '../BufeTooltips';
import TimeFormatter from '../../../commons/TimeFormatter';
import Lib from '../../../commons/lib';
import ForgalomContentHelybenFormField from './ForgalomContentHelybenFormField';
import ProgressButton from '../../../commons/ProgressButton';

class ForgalomContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formBufe: '',
      vasarlastipus: 'K',
      bufek: [],
      termekCsoport: [],
      termek: [],
      termekCsoportId: null,
      modalTetelekState: false,
      modalForgalomState: false,
      currentbufeid: null,
      currentRowIdReszletes: [],
      currentObjReszletes: null,
      dolgozoiKedvezmenyek: [],
      felhasznalok: [],
      termekCsoport2: null,
      termek2: null,
      felhasznalo: null,
      kedvezmeny: null,
      fizmod: null,
      fizModOptions: null,
      fizModSelectOptions: [],
      szemelyId: null,
      helyben: 'true',
      dolgozok: [],
      dataOsszesitettForgalom: null,
      dataOsszesitettForgalomHiba: false,
      dataOsszesitettForgalomLoading: false,
      dataOsszesitettForgalomPreLoad: true,
      dataReszletesForgalom: [],
      dataReszletesForgalomHiba: false,
      dataReszletesForgalomLoading: false,
      dataReszletesForgalomPreLoad: true,
      dataReszletesTetelForgalom: [],
      reszletesForgalomKezdete: moment(TimeFormatter.formatIso(new Date())).startOf('day'),
      reszletesForgalomVege: moment(TimeFormatter.formatIso(new Date())).endOf('day'),
      osszesitettForgalomKezdete: TimeFormatter.formatDate(new Date()),
      osszesitettForgalomVege: TimeFormatter.formatDate(new Date()),
      collapseForgalomOsszesitett: true,
      collapseForgalomReszletes: false,
      defaultCurrencyAzon: null,
      lekerdezesButtonLoading: false,

      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
      exportButtonLoading: false,
    };

    this.onRowSelectReszletes = this.onRowSelectReszletes.bind(this);

    this.kezdeteDatum = null;

    this.vegeDatum = null;

    this.dolgozoiRole = null;

    this.kulsoRole = null;

    this.options = {
      sizePerPage: 25,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ]
    };

    // this.fiztipusSelectOptions = {
    //   Bankkártya: 'Bankkártya',
    //   Készpénz: 'Készpénz'
    // };

    this.reszletesColumns = [
      {
        dataField: 'bufenev',
        text: 'Büfé',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'datum',
        text: 'Dátum',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
        formatter: datum => (datum ? TimeFormatter.formatDateTime(datum) : '')
      },
      {
        dataField: 'azonosito',
        text: 'Rendelésazonosító',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'felhasznalonev',
        text: 'Felhasználó',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'fizmodnev',
        text: 'Fizetési mód',
        // filter: selectFilter({
        //   options: this.fiztipusSelectOptions,
        //   placeholder: 'Összes',
        // }),
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'bruttoar',
        text: 'Bruttó ár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlign,
        sort: true,
        sortFunc: (a, b, order) => {
          a = a.slice(0, -2);
          b = b.slice(0, -2);
          if (order === 'asc') {
            return a - b;
          }
          return b - a;
        }
      },
      {
        dataField: 'kedvezmeny',
        text: 'Kedvezmény',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'eladar',
        text: 'Kedvezményes ár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlign,
        sort: true,
        sortFunc: (a, b, order) => {
          a = a.slice(0, -2);
          b = b.slice(0, -2);
          if (order === 'asc') {
            return a - b;
          }
          return b - a;
        }
      },
      {
        dataField: 'szemelynev',
        text: 'Kedvezmény felhasználója',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      // {
      //   dataField: 'kedvezmeny',
      //   text: 'Kedvezmény típusa',
      //   filter: textFilter({
      //     delay: 400,
      //     placeholder: 'Keresés...',
      //   }),
      //   sort: true
      // }
    ];

    this.reszletesTetelColumns = [
      {
        dataField: 'termekcsoport',
        text: 'Termékcsoport',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'termekrovidneve',
        text: 'Termék rövid neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'cikkneve',
        text: 'Cikk neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'bruttoegysegar',
        text: 'Bruttó egységár',
        style: NumberFormatter.styleTextAlign,
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'mennyiseg',
        text: 'Mennyiség',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlign,
        formatter: NumberFormatter.formatterSpaceOsszeg,
        sort: true
      },
      {
        dataField: 'bruttoar',
        text: 'Bruttó ár',
        style: NumberFormatter.styleTextAlign,
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      // {
      //   dataField: 'eladasiar',
      //   text: 'Eladási ár',
      //   filter: textFilter({
      //     delay: 400,
      //     placeholder: 'Keresés...',
      //   }),
      //   sort: true
      // },
      // {
      //   dataField: 'kedvezmenytipusa',
      //   text: 'Kedvezmény típusa',
      //   filter: textFilter({
      //     delay: 400,
      //     placeholder: 'Keresés...',
      //   }),
      //   sort: true
      // },
      // {
      //   dataField: 'kedvezmeny',
      //   text: 'Kedvezmény',
      //   filter: textFilter({
      //     delay: 400,
      //     placeholder: 'Keresés...',
      //   }),
      //   sort: true
      // }
    ];

    this.selectRowPropReszletes = {
      mode: 'radio',
      onSelect: this.onRowSelectReszletes
    };

    this.osszesitettDolgozoColumns = [
      {
        dataField: 'bufenev',
        text: 'Büfé',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'szemelynev',
        text: 'Dolgozó neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
      },
      {
        dataField: 'fizmodnev',
        text: 'Fizetési mód',
        // filter: selectFilter({
        //   options: this.state.fizModSelectOptions,
        //   placeholder: 'Összes',
        // }),
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'eladar',
        text: 'Eladási ár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
        style: NumberFormatter.styleTextAlign,
        sortFunc: (a, b, order) => {
          a = a.slice(0, -2);
          b = b.slice(0, -2);
          if (order === 'asc') {
            return a - b;
          }
          return b - a;
        }
      },
      {
        dataField: 'sum',
        text: 'SUM',
        hidden: true
      },
    ];

    this.osszesitettColumns = [
      {
        dataField: 'bufenev',
        text: 'Büfé',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'szemelynev',
        text: 'Dolgozó neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true,
        hidden: true
      },
      {
        dataField: 'fizmodnev',
        text: 'Fizetési mód',
        // filter: selectFilter({
        //   options: this.state.fizModSelectOptions,
        //   placeholder: 'Összes',
        // }),
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        sort: true
      },
      {
        dataField: 'eladar',
        text: 'Eladási ár',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlign,
        sort: true,
        sortFunc: (a, b, order) => {
          a = a.slice(0, -2);
          b = b.slice(0, -2);
          if (order === 'asc') {
            return a - b;
          }
          return b - a;
        }
      },
      {
        dataField: 'sum',
        text: 'SUM',
        hidden: true,
      },
    ];
  }

  hasRoleSpec = (roleName) => {
    return this.props.globals.hasRoleSpec(roleName);
  }

  checkTipusRoles = () => {
    this.dolgozoiRole = this.hasRoleSpec(['BUFE_DOLGOZOI']);
    this.kulsoRole = this.hasRoleSpec(['BUFE_KULSOERT']);
  }

  componentDidMount() {
    this.checkTipusRoles();
    this.preparation();
    this.selected = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTab !== '3' && this.props.activeTab === '3') {
      this.preparation();
    }
  }

  preparation = () => {
    this.getBufek();
    this.setCollapse();
    this.getDefaultCurrency();
    this.getFizetesiMod();
  }

  getDefaultCurrency = () => {
    Services.getDefaultCurrency((err, res) => {
      if (!err) {
        this.setState({ defaultCurrencyAzon: res[0].azonosito });
      } else {
        this.setState({ defaultCurrencyAzon: '' });
      }
    });
  }

  getFizetesiMod = () => {
    Services.getDistinctFizetesiMod((err, res) => {
      if (!err) {
        let fizModOptions = [];
        let fizModSelectOptions = {};
        res[0].forEach((e) => {
          fizModOptions.push(<option key={e.variansid ? e.variansid : e.id} value={e.variansid ? e.variansid : e.id}>{e.variansnev ? e.variansnev : e.nev}</option>);
          fizModSelectOptions[e.variansnev ? e.variansnev : e.nev] = e.variansnev ? e.variansnev : e.nev;
        });
        this.setState({ fizModOptions: fizModOptions, fizModSelectOptions: fizModSelectOptions });
      } else {
        this.setState({ fizModOptions: [], fizModSelectOptions: [] });
      }
    });
  }

  collapseForgalomOsszesitett = () => {
    this.setState({
      collapseForgalomOsszesitett: !this.state.collapseForgalomOsszesitett,
    });
  }

  collapseForgalomReszletes = () => {
    this.setState({
      collapseForgalomReszletes: !this.state.collapseForgalomReszletes,
    });
  }

  onRowSelectReszletes(row, isSelect, rowIndex, e) {
    this.setState({ currentRowIdReszletes: [rowIndex], currentObjReszletes: row }, () => {
      Services.listForgalomTetelek(row.forgalomid, (err, res) => {
        if (!err) {
          res[0].forEach(element => {
            element.eladasiar = NumberFormatter.addSpacesToString(element.eladasiar, NumberFormatter.OSSZEG) + " " + this.state.defaultCurrencyAzon;
            element.bruttoar = NumberFormatter.addSpacesToString(element.bruttoar, NumberFormatter.OSSZEG) + " " + this.state.defaultCurrencyAzon;
            element.bruttoegysegar = NumberFormatter.addSpacesToString(element.bruttoegysegar, NumberFormatter.OSSZEG) + " " + this.state.defaultCurrencyAzon;
          });
          this.setState({ dataReszletesTetelForgalom: res[0] });
        }
      })
    });
  }

  getDolgozok = (id) => {
    if (id)
      Services.listDolgozok(id, (err, res) => {
        if (!err) {
          this.setState({ dolgozok: res[0] });    
        }
      });
  }

  renderDolgozokOptions = () => {

    let dolgozok = [];
    if (this.state.dolgozok) {
      this.state.dolgozok.forEach((e) => {
        dolgozok.push(
          <option key={e.id} value={e.id}>{e.nev}</option>
        );
      });
    }
    return dolgozok;
  }

  termekcsoportIsEmpty = () => {
    if (this.state.termekCsoport && this.state.termekCsoport.length !== 0) return false;
    else return true;
  }

  termekIsEmpty = () => {
    if (this.state.termek && this.state.termek.length !== 0) return false;
    else return true;
  }

  toggleForgalomModal = () => {
    this.setState(prevState => ({ modalForgalomState: !prevState.modalForgalomState }));
  }

  toggleTetelekModal = () => {
    this.setState(prevState => ({ modalTetelekState: !prevState.modalTetelekState }));
  }

  renderStatusOptions = () => {
    return this.state.bufek.map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.kod + ')'}</option>);
  }

  renderCsoportStatusOptions = () => {
    return this.state.termekCsoport.map(e => <option key={e.id} value={e.id}>{e.nev + ' (' + e.azonosito + ')'}</option>);
  }

  renderTermekStatusOptions = () => {
    return this.state.termek.map(e => <option key={e.id} value={e.id}>{e.rovidnev + ' (' + e.azonosito + ')'}</option>);
  }

  renderFelhasznaloStatusOptions = () => {
    return this.state.felhasznalok.map(e => <option key={e.id} value={e.id}>{e.szemelynev}</option>);
  }

  renderKedvezmenyStatusOptions = () => {
    return this.state.termek.map(e => <option key={e.id} value={e.id}>{e.rovidnev + ' (' + e.azonosito + ')'}</option>);
  }

  handleOsszesitettForgalomClick = () => {
    let forgalomOsszesitettBean = {};
    if (this.state.currentbufeid) {
      forgalomOsszesitettBean.bufeid = parseInt(this.state.currentbufeid, 10);
    }
    forgalomOsszesitettBean.kezdete = TimeFormatter.formatIso(this.state.osszesitettForgalomKezdete);
    if (this.state.osszesitettForgalomVege)
      forgalomOsszesitettBean.vege = TimeFormatter.formatIso(moment(this.state.osszesitettForgalomVege).endOf('day'));
    forgalomOsszesitettBean.vasarlastipus = this.state.vasarlastipus ? this.state.vasarlastipus : null;

    if (this.state.dolgozok !== [] && this.state.vasarlastipus === 'D') {
      forgalomOsszesitettBean.szemelyId = parseInt(this.state.szemelyId, 10);
      forgalomOsszesitettBean.vasarlastipus = this.state.vasarlastipus ? this.state.vasarlastipus : null;
    }
    if (this.state.vasarlastipus === 'K') {
      forgalomOsszesitettBean.szemelyId = null;
    }
    forgalomOsszesitettBean.fizmodid = this.state.fizmod;
    forgalomOsszesitettBean.reszletes = false;
    forgalomOsszesitettBean.helyben = this.state.helyben;

    this.setState({ dataOsszesitettForgalomLoading: true, dataOsszesitettForgalomPreLoad: false, dataOsszesitettForgalomHiba: false, dataOsszesitettForgalom: [], lekerdezesButtonLoading: true });
    
    Services.listForgalomReszletes(forgalomOsszesitettBean, (err, res) => {
      if (!err) {
        this.kezdeteDatum = forgalomOsszesitettBean.kezdete;
        this.vegeDatum = forgalomOsszesitettBean.vege;
        res[0].forEach((element) => {
          let datum = new Date(element.datum);
          element.datum = datum.getFullYear() + '-' + (datum.getMonth() < 10 ? '0' + datum.getMonth() : datum.getMonth()) + '-' + (datum.getDate() < 10 ? '0' + datum.getDate() : datum.getDate());
          element.sum = parseFloat(element.eladar, 10);
          element.eladar = NumberFormatter.addSpacesToString(element.eladar, NumberFormatter.OSSZEG) + ' ' + this.state.defaultCurrencyAzon;
        });
        this.setState({ dataOsszesitettForgalom: res[0], vasarlastipusLek: this.state.vasarlastipus, lekerdezesButtonLoading: false });
      } else if (err.status != '409') {
        this.setState({ dataOsszesitettForgalomHiba: true, lekerdezesButtonLoading: false });
      }
      this.setState({ dataOsszesitettForgalomLoading: false, lekerdezesButtonLoading: false });
    });
  }

  handleReszletesForgalomClick = () => {
    let forgalomReszletesBean = {};
    forgalomReszletesBean.bufeid = this.state.currentbufeid;
    forgalomReszletesBean.kezdete = TimeFormatter.formatIso(this.state.reszletesForgalomKezdete);
    forgalomReszletesBean.vege = TimeFormatter.formatIso(this.state.reszletesForgalomVege);
    forgalomReszletesBean.termekcsoportid = this.state.termekCsoport2;
    forgalomReszletesBean.termekid = this.state.termek2;
    forgalomReszletesBean.felhasznaloid = this.state.felhasznalo === "" ? null : this.state.felhasznalo;
    forgalomReszletesBean.kedvezmeny = this.state.kedvezmeny;
    forgalomReszletesBean.reszletes = true;
    this.setState({ dataReszletesTetelForgalom: [], dataReszletesForgalomLoading: true, dataReszletesForgalomPreLoad: false, dataReszletesForgalomHiba: false, dataReszletesForgalom: [] });
    Services.listForgalomReszletes(forgalomReszletesBean, (err, res) => {
      if (!err) {
        let i = 0;
        this.reszlKezdeteDatum = forgalomReszletesBean.kezdete;
        this.reszlVegeDatum = forgalomReszletesBean.vege;
        res[0].forEach(element => {
          let datum = new Date(element.datum);
          element.id = i;
          i++;
          element.datum = datum.getFullYear() + '-' + ((datum.getMonth() + 1) < 10 ? '0' + (datum.getMonth() + 1) : (datum.getMonth() + 1)) + '-' + (datum.getDate() < 10 ? '0' + datum.getDate() : datum.getDate()) + ' ' + (datum.getHours() < 10 ? '0' + datum.getHours() : datum.getHours()) + ':' + (datum.getMinutes() < 10 ? '0' + datum.getMinutes() : datum.getMinutes())  + ':' + (datum.getSeconds() < 10 ? '0' + datum.getSeconds() : datum.getSeconds());
          element.sumelad = parseFloat(element.eladar, 10);
          element.sumbrutto = parseFloat(element.bruttoar, 10);
          element.eladar = NumberFormatter.addSpacesToString(element.eladar, NumberFormatter.OSSZEG) + " " + this.state.defaultCurrencyAzon;
          element.bruttoar = NumberFormatter.addSpacesToString(element.bruttoar, NumberFormatter.OSSZEG) + " " + this.state.defaultCurrencyAzon;
        });
        this.setState({ dataReszletesForgalom: res[0] });
      } else if (err.status != '409') {
        this.setState({ dataReszletesForgalomHiba: true });
      }
      this.setState({ dataReszletesForgalomLoading: false });
    });
  }

  fizmodChange = (e) => {
    this.setState({
      fizmod: e.target.value,
    });
  }

  vasarlastipusChange = (e) => {
    this.setState({
      vasarlastipus: e.target.value
    }, () => {
      if (this.state.vasarlastipus === 'D') {
        this.getDolgozok(this.state.currentbufeid);
      } 
      if(this.state.vasarlastipus === 'K') {
        this.helybenChange({ target: { value: 'true' }});
      }
    });
  }

  dolgozonevChange = (e) => {
    this.setState({
      szemelyId: e.target.value
    });
  }

  helybenChange = (e) => {
    this.setState({
      helyben: e.target.value
    });
  }

  // fiztipusFormatter = (cell) => {
  //   switch (cell) {
  //     case 'K':
  //       return <span className="badge badge-success">Készpénz</span>;
  //     case 'B':
  //       return <span className="badge badge-default">Bankkártya</span>;
  //     default:
  //       return <span className="badge badge-default">X</span>;
  //   }
  // }

  setCollapse = () => {
    // let reszJog = this.hasRole('BUFE_FORGALOMRESZ');
    this.setState({ collapseForgalomOsszesitett: true, collapseForgalomReszletes: true });
  }

  getBufek = () => {
    Services.listBufekSelect((err, res) => {
      if (!err) {
        this.setState({ bufek: res[0] });

        this.setState({ currentbufeid: res[0][0].id });
        this.getTermekcsoportListSelect(res[0][0].id);
      }
    });
  }

  getTermekcsoportListSelect = (id) => {
    Services.listTermekCsoportSelect(id, (err, res) => {
      if (!err) {
        this.setState({ termekCsoport: res[0] });
      }
    });
  }

  getTermekList = (bufeid, tcsid) => {
    Services.listTermekByBufe(bufeid, tcsid, (err, res) => {
      if (!err) {
        this.setState({ termek: res[0] });
      }
    });
  }

  getUsersList = (bufeid) => {
    Services.getUsersList(bufeid, (err, res) => {
      if (!err) {
        this.setState({ felhasznalok: res[0] });
      } else {
        this.setState({ felhasznalok: [] });
      }
    });
  }

  bufeValaszto = (osszesitett_e) => {
    return (
      <RFForm onSubmit={() => {}}>
        <RFField
          type="select"
          name="formBufe"
          label="Büfé neve:"
          value={this.state.currentbufeid}
          onChange={osszesitett_e ? this.handleOsszBufeSelectChange : this.handleReszBufeSelectChange}
          defaultSelect={<option value="" >Válassz büfét...</option>}
          selectOptions={this.renderStatusOptions()}
        />
      </RFForm>
    );
  }

  handleOsszBufeSelectChange = (e) => {
    this.setState({ currentbufeid: e.target.value });

    this.getDolgozok(e.target.value);
  }

  handleReszBufeSelectChange = (e) => {
    this.setState({ currentbufeid: e.target.value, termekCsoport2: null, termek2: null }, () => {
      if (this.state.currentbufeid) {
        this.getTermekcsoportListSelect(this.state.currentbufeid);
        this.getTermekList(this.state.currentbufeid, this.state.termekCsoport2);
        this.getUsersList(this.state.currentbufeid);
      }
    });
  }

  handleCsoportSelectChange = (e) => {
    this.getTermekList(this.state.currentbufeid, e.target.value);
    this.setState({ termekCsoport2: e.target.value });
  }

  handleTermekSelectChange = (e) => {
    this.setState({ termek2: e.target.value });
  }

  handleFelhasznaloSelectChange = (e) => {
    this.setState({ felhasznalo: e.target.value });
  }

  handleKedvezmenySelectChange = (e) => {
    this.setState({ kedvezmeny: e.target.value });
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  formDatumChange = (e, v) => {
    let currentValue = v === '' ? null : v;
    this.setState({ datum: currentValue });
  }

  handleDateInputChange = (e, v, name) => {
    const value = v === '' ? null : v;
    this.setState({
      [name]: value
    });
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  todayDate = () => {
    let date = new Date();
    let month = date.getMonth() + 1;
    return date.getFullYear() + '_' + (month < 10 ? '0' + month : month) + '_' + date.getDate();
  }

  date = () => {
    let date = new Date();
    let month = date.getMonth() + 1;
    return date.getFullYear() + '_' + (month < 10 ? '0' + month : month) + '_' + date.getDate();
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      
      switch (type) {
        case 'FORMFORGALOMKEZDETE':
          this.setState({ reszletesForgalomKezdete: (moment(e).startOf('day')) });
          break;
        case 'FORMFORGALOMVEGE':
          this.setState({ reszletesForgalomVege: (moment(e).endOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMFORGALOMKEZDETE':
          //this.handleDateInputChange(e, v, 'reszletesForgalomKezdete')
          this.setState({ reszletesForgalomKezdete: (v === '' ? null : e) });
          break;
        case 'FORMFORGALOMVEGE':
          this.setState({ reszletesForgalomVege: (v === '' ? null : e) });
          break;
        default:
          break;
      }
    }
  }

  render() {
    let cardStyle = {
      padding: 10
    };

    return (
      <div>
      <div className="animated fadeIn">
        <div className="card">
          <div className="card-header">
            Forgalom
            {/* <YouTube data={videoData} /> */}
          </div>
          <div style={cardStyle}>
            <div className="col-md-12">
        {this.hasRoleSpec(['BUFE_FORGALOMOSSZ']) ? (
          <React.Fragment>
            <Button
              className="szerzodes-collapse-buttons"
              color="success"
              onClick={this.collapseForgalomOsszesitett}
            >
              {'Összesített forgalom'}
              {this.state.collapseForgalomOsszesitett ? '↑' : '↓'}
            </Button>
            <CustomTooltip text={getTooltip('osszesitettforgalom')} id="osszesitettforgalomTT" />
            <br />
            <Collapse isOpen={this.state.collapseForgalomOsszesitett}>
              <RFForm onSubmit={() => {}}>
                <div className="row">
                  <div className="col-md-4">
                    {this.bufeValaszto(true)}
                  </div>
                  <div className="row col-md-8">
                    <div className="col-md-5">
                      <DatePicker
                        label="Kezdete:"
                        placeholder="éééé-hh-nn"
                        onChange={(e, v) => this.handleDateInputChange(e, v, 'osszesitettForgalomKezdete')}
                        value={this.state.osszesitettForgalomKezdete && new Date(this.state.osszesitettForgalomKezdete)}
                        // type="select"
                        id="osszesitettForgalomKezdete"
                        name="osszesitettForgalomKezdete"
                        required
                      />
                    </div>
                    <div className="col-md-5">
                      <DatePicker
                        label="Vége:"
                        placeholder="éééé-hh-nn"
                        onChange={(e, v) => this.handleDateInputChange(e, v, 'osszesitettForgalomVege')}
                        value={this.state.osszesitettForgalomVege && new Date(this.state.osszesitettForgalomVege)}
                        // type="select"
                        id="osszesitettForgalomVege"
                        name="osszesitettForgalomVege"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <RFField
                      type="select"
                      name="fizmod"
                      label="Fizetési mód:"
                      onChange={this.handleInputChange}
                      value={this.state.fizmod}
                      defaultSelect={<option value={null}>  {'Válassz fizetési módot...'} </option>}
                      selectOptions={this.state.fizModOptions}
                    />
                  </div>
                  {
                    (this.dolgozoiRole === true || this.kulsoRole === true) ? (
                      <div className="col-md-8 row">
                        <div className="col-md-4">
                          <RFField
                            type="select"
                            name="vasarlastipus"
                            label="Vásárlás típusa:"
                            onChange={this.vasarlastipusChange}
                            value={this.state.vasarlastipus}
                            selectOptions={<React.Fragment>
                              {
                                this.dolgozoiRole === true && this.kulsoRole === true && (
                                  <option value="O">
                                    {'Összes'}
                                  </option>
                                )
                              }
                              {
                                this.kulsoRole === true && (
                                  <option value="K">
                                    {'Külső értékesítés'}
                                  </option>
                                )
                              }
                              {
                                this.dolgozoiRole === true && (
                                  <option value="D">
                                    {'Dolgozói'}
                                  </option>
                                )
                              }
                              </React.Fragment>}
                            required
                          />
                        </div>
                        <div id="dolgozonev" className="col-md-4" hidden={(this.state.vasarlastipus === 'D' && this.state.dolgozok !== [] && this.props.globals.hasRoleSpec(['BUFE_FORGALOMOSSZ']) && this.state.currentbufeid) ? false : true}>
                          <RFField
                            type="select"
                            name="dolgozonev"
                            label="Dolgozó neve:"
                            onChange={this.dolgozonevChange}
                            value={this.state.szemelyId}
                            defaultSelect={<option value=""> {'Összes'} </option>}
                            selectOptions={this.state.dolgozok !== [] && this.state.vasarlastipus === 'D' && this.renderDolgozokOptions()}
                            required
                          />  
                        </div>
                        <div className={`${(this.state.vasarlastipus === 'D' && this.state.dolgozok !== [] && this.props.globals.hasRoleSpec(['BUFE_FORGALOMOSSZ']) && this.state.currentbufeid) ? 'col-md-4' : 'col-md-8'}`}>
                          <ForgalomContentHelybenFormField helyben={this.state.helyben} onChange={this.helybenChange} />
                        </div>
                      </div>
                    ) : (
                      <div className={'col-md-8'}>
                          <RFField
                            type="select"
                            name="helyben"
                            label="Helyben fogyasztva:"
                            onChange={this.helybenChange}
                            value={this.state.helyben}
                            defaultSelect={<option value="">Válassz értéket...</option>}
                            selectOptions={
                              <React.Fragment>
                                <option value="true">Igen</option>
                                <option value="false">Nem</option>
                              </React.Fragment>
                            }
                          />
                        </div>
                    )
                  }
                </div>
                <div className="row">
                  <div className="col-md-2">
                    <ProgressButton className="pull-left table-new-button" color="primary"
                      onClick={this.handleOsszesitettForgalomClick}
                      loading={this.state.lekerdezesButtonLoading}
                      style={{ marginTop: 15 }}>
                      {'Lekérdezés'}
                    </ProgressButton>
                  </div>
                </div>
              </RFForm>

              {this.state.dataOsszesitettForgalomPreLoad ? <QueryEmptyState hasImage /> :
                this.state.dataOsszesitettForgalomLoading ? <Loader /> :
                  this.state.dataOsszesitettForgalomHiba ? <NetworkEmptyState hasImage /> :
                    this.state.dataOsszesitettForgalom.length === 0 ? <DataEmptyState hasImage /> : (
                      <>
                        <ProgressButton
                          type="button"
                          className="btn btn-success"
                          style={{ marginBottom: 10 }}
                          loading={this.state.exportButtonLoading}
                          onClick={() => {

                            if (this.state.vasarlastipusLek === 'D') {
                              const datas = JSON.parse(JSON.stringify(this.lista.filterContext.data));

                              let xlsDatas = [];
                              let fizmodSet = new Set();
                              let bufeSet = new Set();
                              datas.forEach((element) => {
                                xlsDatas.push([
                                  element.bufenev, element.fizmodnev, element.sum, element.szemelynev
                                ]);
                                fizmodSet.add(element.fizmodnev);
                                bufeSet.add(element.bufenev);
                              });
  
                              let kezdeteFormated = TimeFormatter.formatDateNoDots(this.kezdeteDatum);
                              let vegeFormated = TimeFormatter.formatDateNoDots(this.vegeDatum);
  
                              const wb = new Excel.Workbook();
                              const ws = wb.addWorksheet(kezdeteFormated + '-' + vegeFormated);
  
                              ws.columns = [
                                { key: 'bufe', width: 35 },
                                { key: 'fizmod', width: 35 },
                                { key: 'eladar', width: 35, style: { alignment: { horizontal: 'right'}, numFmt: '# ##0 "' + this.state.defaultCurrencyAzon + '"' } },
                                { key: 'szemelynev', width: 35 }
                              ];

                              let offset = datas.length + 3;
                              if (bufeSet.size > 1) {
                                fizmodSet.forEach(item => {
                                  ws.getCell(`B${offset}`).value = item;
                                  ws.getCell(`C${offset}`).value = { formula: 'SUMIF(B2:B'+ (datas.length + 1) +',B' + offset++ + ',C2:C' + (datas.length + 1) +')' };
                                });
                              }

                              ws.getCell(`B${offset}`).value = 'Összesen:';
                              ws.getCell(`B${offset}`).font = { bold: true};
                              ws.getCell(`C${offset}`).value = { formula: 'SUM(C2:C'+ (datas.length + 1) +')' };
                              ws.getCell(`C${offset}`).font = { bold: true};
  
                              ws.addTable({
                                name: 'Táblázat',
                                ref: 'A1',
                                headerRow: true,
                                style: {
                                  theme: 'TableStyleLight1',
                                  showRowStripes: true,
                                },
                                columns: [
                                  { name: 'Büfé', filterButton: true },
                                  { name: 'Fizetési mód', filterButton: true },
                                  { name: 'Eladási ár', filterButton: true },
                                  { name: 'Dolgozó neve', filterButton: true }
                                ],
                                rows: xlsDatas,
                              });
                              ws.getRow(1).alignment = 'left';
                              if (datas.length > 0) {
                                let kezdeteFormated = TimeFormatter.formatDateNoDots(this.kezdeteDatum);
                                let vegeFormated = TimeFormatter.formatDateNoDots(this.vegeDatum);
                                this.setState({ exportButtonLoading: true });
                                wb.xlsx.writeBuffer()
                                  .then(buffer => FileSaver.saveAs(new Blob([buffer]), 'bufeossz_' + kezdeteFormated + '-' + vegeFormated + '.xlsx'))
                                  .catch()
                                  .finally(() => {
                                    this.setState({ exportButtonLoading: false });
                                  });
                              }
                            } else {
                              const datas = JSON.parse(JSON.stringify(this.lista.filterContext.data));

                              let fizmodSet = new Set();
                              let xlsDatas = [];
                              let bufeSet = new Set();
                              datas.forEach((element) => {
                                xlsDatas.push([element.bufenev, element.fizmodnev, element.sum]);
                                fizmodSet.add(element.fizmodnev);
                                bufeSet.add(element.bufenev);
                              });

                              let kezdeteFormated = TimeFormatter.formatDateNoDots(this.kezdeteDatum);
                              let vegeFormated = TimeFormatter.formatDateNoDots(this.vegeDatum);

                              const wb = new Excel.Workbook();
                              const ws = wb.addWorksheet(kezdeteFormated + '-' + vegeFormated);

                              ws.columns = [
                                { key: 'bufe', width: 35 },
                                { key: 'fizmod', width: 35 },
                                { key: 'eladar', width: 35, style: { alignment: { horizontal: 'right'}, numFmt: '# ##0 "' + this.state.defaultCurrencyAzon + '"' } },
                              ];

                              let offset = datas.length + 3;
                              if (bufeSet.size > 1) {
                                fizmodSet.forEach((item) => {
                                  ws.getCell(`B${offset}`).value = item;
                                  ws.getCell(`C${offset}`).value = { formula: 'SUMIF(B2:B'+ (datas.length + 1) +',B' + offset++ + ',C2:C' + (datas.length + 1) +')' };
                                });
                              }

                              ws.getCell(`B${offset}`).value = 'Összesen:';
                              ws.getCell(`B${offset}`).font = { bold: true};
                              ws.getCell(`C${offset}`).value = { formula: 'SUM(C2:C'+ (datas.length + 1) +')' };
                              ws.getCell(`C${offset}`).font = { bold: true};

                              ws.addTable({
                                name: 'Táblázat',
                                ref: 'A1',
                                headerRow: true,
                                style: {
                                  theme: 'TableStyleLight1',
                                  showRowStripes: true,
                                },
                                columns: [
                                  { name: 'Büfé', filterButton: true },
                                  { name: 'Fizetési mód', filterButton: true },
                                  { name: 'Eladási ár', filterButton: true },
                                ],
                                rows: xlsDatas,
                              });
                              ws.getRow(1).alignment = 'left';
                              if (datas.length > 0) {
                                let kezdeteFormated = TimeFormatter.formatDateNoDots(this.kezdeteDatum);
                                let vegeFormated = TimeFormatter.formatDateNoDots(this.vegeDatum);
                                this.setState({ exportButtonLoading: true });
                                wb.xlsx.writeBuffer()
                                  .then(buffer => FileSaver.saveAs(new Blob([buffer]), 'bufeossz_' + kezdeteFormated + '-' + vegeFormated + '.xlsx'))
                                  .catch()
                                  .finally(() => {
                                    this.setState({ exportButtonLoading: false });
                                  });
                              }
                            }
                          }}
                        >
                          Export xlsx
                        </ProgressButton>
                        <BootstrapTable2
                          bootstrap4
                          ref={((c) => { this.lista = c; })}
                          keyField="id"
                          filter={filterFactory()}
                          data={this.state.dataOsszesitettForgalom}
                          columns={this.state.vasarlastipusLek === 'D' ? this.osszesitettDolgozoColumns : this.osszesitettColumns}
                          pagination={paginationFactory(Lib.bootstraptableProps)}
                        />
                      </>
                    )
              }
            </Collapse>
          </React.Fragment>
        ) : <div />}
        {this.hasRoleSpec(['BUFE_FORGALOMRESZ']) ? (
          <React.Fragment>
            <Button
              className="szerzodes-collapse-buttons"
              color="success"
              onClick={this.collapseForgalomReszletes}
            >
              {'Részletes forgalom'}
              {this.state.collapseForgalomReszletes ? '↑' : '↓'}
            </Button>
            <CustomTooltip text={getTooltip('reszletesforgalom')} id="reszletesforgalomTT" />
            <br />
            <Collapse isOpen={this.state.collapseForgalomReszletes}>
              <RFForm onSubmit={() => {}}>
                <div className="row">
                  <div className="col-md-4">
                    {this.bufeValaszto(false)}
                  </div>
                  <div className="col-md-4">
                    <DatetimePicker
                      label="Kezdete:"
                      placeholder="éééé-hh-nn"
                      //onChange={(e, v) => this.handleDateInputChange(e, v, 'reszletesForgalomKezdete')}
                      value={this.state.reszletesForgalomKezdete && new Date(this.state.reszletesForgalomKezdete)}
                      onChange={(e,v) => {this.handleDateChange(e,v,'FORMFORGALOMKEZDETE')}}
                      onSelect={(e,v) => { this.selected = true }}
                      timePrecision="seconds"
                      // type="select"
                      id="reszletesForgalomKezdete"
                      name="reszletesForgalomKezdete"
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <DatetimePicker
                      label="Vége:"
                      placeholder="éééé-hh-nn"
                      //onChange={(e, v) => this.handleDateInputChange(e, v, 'reszletesForgalomVege')}
                      value={this.state.reszletesForgalomVege && new Date(this.state.reszletesForgalomVege)}
                      onChange={(e,v) => {this.handleDateChange(e,v,'FORMFORGALOMVEGE')}}
                      onSelect={(e,v) => { this.selected = true }}
                      timePrecision="seconds"
                      // type="select"
                      id="reszletesForgalomVege"
                      name="reszletesForgalomVege"
                      required
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2">
                    <RFField
                      disabled={this.termekcsoportIsEmpty()}
                      type="select"
                      name="termekCsoport"
                      label="Termékcsoport:"
                      value={this.state.termekCsoport2}
                      onChange={this.handleCsoportSelectChange}
                      defaultSelect={<option value=''>Válassz termékcsoportot...</option>}
                      selectOptions={this.renderCsoportStatusOptions()}
                    />
                  </div>

                  <div className="col-md-2">
                    <RFField
                      disabled={!this.state.termekCsoport2}
                      type="select"
                      name="termek"
                      label="Termék:"
                      value={this.state.termek2}
                      onChange={this.handleTermekSelectChange}
                      defaultSelect={<option value=''>Válassz terméket...</option>}
                      selectOptions={this.renderTermekStatusOptions()}
                    />
                  </div>

                  <div className="col-md-2">
                    <RFField
                      type="select"
                      name="felhasznalo"
                      label="Felhasználó:"
                      value={this.state.felhasznalo}
                      onChange={this.handleFelhasznaloSelectChange}
                      defaultSelect={<option value=''>Válassz felhasználót...</option>}
                      selectOptions={this.renderFelhasznaloStatusOptions()}
                    />
                  </div>

                  <div className="col-md-2">
                    <ProgressButton className="pull-left table-new-button" color="primary"
                      onClick={this.handleReszletesForgalomClick}
                      loading={this.state.dataReszletesForgalomLoading}
                      style={{ marginTop: 30 }}>
                      {'Lekérdezés'}
                    </ProgressButton>
                  </div>
                </div>
              </RFForm>

              {this.state.dataReszletesForgalomPreLoad ? <QueryEmptyState hasImage /> :
                this.state.dataReszletesForgalomLoading ? <Loader /> :
                  this.state.dataReszletesForgalomHiba ? <NetworkEmptyState hasImage submitClick={this.handleReszletesForgalomClick} /> :
                    this.state.dataReszletesForgalom.length === 0 ? <DataEmptyState hasImage /> : 
                      <>
                      <ProgressButton
                        type="button"
                        loading={this.state.exportButtonLoading}
                        className="btn btn-success"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          const datas = JSON.parse(JSON.stringify(this.lista2.filterContext.data));

                          let fizmodSet = new Set();
                          let xlsDatas = [];
                          datas.forEach((element) => {
                            xlsDatas.push([
                              element.bufenev, element.datum, element.azonosito, element.felhasznalonev, element.fizmodnev, element.sumbrutto, element.kedvezmeny, element.sumelad, element.szemelynev
                            ]);
                            fizmodSet.add(element.fizmodnev);
                          });

                          let kezdeteFormated = TimeFormatter.formatDateNoDots(this.reszlKezdeteDatum);
                          let vegeFormated = TimeFormatter.formatDateNoDots(this.reszlVegeDatum);
                          let osszegFormat = '# ##0 "' + this.state.defaultCurrencyAzon + '"';

                          const wb = new Excel.Workbook();
                          const ws = wb.addWorksheet(kezdeteFormated + '-' + vegeFormated);

                          ws.columns = [
                            { key: 'bufenev', width: 35 },
                            { key: 'datum', width: 35 },
                            { key: 'azonosito', width: 40 },
                            { key: 'felhasznalonev', width: 35 },
                            { key: 'fizmodnev', width: 35 },
                            { key: 'bruttoar', width: 35, style: { alignment: { horizontal: 'right'}, numFmt: osszegFormat} },
                            { key: 'kedvezmeny', width: 35 },
                            { key: 'eladar', width: 35, style: { alignment: { horizontal: 'right'}, numFmt: osszegFormat} },
                            { key: 'szemelynev', width: 35 }
                          ];

                          let offset = datas.length + 3;
                              fizmodSet.forEach(item => {
                                ws.getCell(`E${offset}`).value = item;
                                ws.getCell(`F${offset}`).value = { formula: 'SUMIF(E2:E'+ (datas.length + 1) +',E' + offset + ',F2:F' + (datas.length + 1) +')' };
                                ws.getCell(`H${offset}`).value = { formula: 'SUMIF(E2:E'+ (datas.length + 1) +',E' + offset++ + ',H2:H' + (datas.length + 1) +')' };
                              });

                              ws.getCell(`E${offset}`).value = 'Összesen:';
                              ws.getCell(`E${offset}`).font = { bold: true};
                              ws.getCell(`F${offset}`).value = { formula: 'SUM(F2:F'+ (datas.length + 1) +')' };
                              ws.getCell(`F${offset}`).font = { bold: true};
                              ws.getCell(`H${offset}`).value = { formula: 'SUM(H2:H'+ (datas.length + 1) +')' };
                              ws.getCell(`H${offset}`).font = { bold: true};

                          ws.addTable({
                            name: 'Táblázat',
                            ref: 'A1',
                            headerRow: true,
                            style: {
                              theme: 'TableStyleLight1',
                              showRowStripes: true,
                            },
                            columns: [
                              { name: 'Büfé', filterButton: true },
                              { name: 'Dátum', filterButton: true },
                              { name: 'Rendelésazonosító', filterButton: true },
                              { name: 'Felhasználó', filterButton: true },
                              { name: 'Fizetési mód', filterButton: true },
                              { name: 'Bruttó ár', filterButton: true },
                              { name: 'Kedvezmény', filterButton: true },
                              { name: 'Kedvezményes ár', filterButton: true },
                              { name: 'Kedvezmény felhasználója', filterButton: true }
                            ],
                            rows: xlsDatas,
                          });
                          ws.getRow(1).alignment = 'left';
                          if (datas.length > 0) {
                            this.setState({ exportButtonLoading: true });
                            wb.xlsx.writeBuffer()
                              .then(buffer => FileSaver.saveAs(new Blob([buffer]), 'bufereszl_' + kezdeteFormated + '-' + vegeFormated + '.xlsx'))
                              .catch()
                              .finally(() => {
                                this.setState({ exportButtonLoading: false });
                              });
                          }
                        }}
                      >
                        Export xlsx
                      </ProgressButton>
                      <BootstrapTable2
                        bootstrap4
                        keyField="id"
                        ref={((c) => { this.lista2 = c; })}
                        data={this.state.dataReszletesForgalom}
                        columns={this.reszletesColumns}
                        filter={filterFactory()}
                        pagination={paginationFactory(Lib.bootstraptableProps)}
                        selected={this.state.currentRowIdReszletes}
                        selectRow={this.selectRowPropReszletes}
                      />
                    </>
              }
              {this.state.dataReszletesTetelForgalom.length !== 0 ?
                <BootstrapTable2
                  bootstrap4
                  keyField="id"
                  data={this.state.dataReszletesTetelForgalom}
                  columns={this.reszletesTetelColumns}
                  filter={filterFactory()}
                  pagination={paginationFactory(Lib.bootstraptableProps)}
                />
                : <div />}
            </Collapse>
          </React.Fragment>
        ) : <div />}
      </div>
      </div>
      </div>
      </div>
      </div>
    );
  }
}

ForgalomContent.propTypes = {
  globals: PropTypes.object
};

export default ForgalomContent;
